import {
  Component,
  ChangeDetectorRef,
  HostListener,
  Renderer2,
  ViewChild,
  ElementRef,
} from '@angular/core';

import {
  CommonModule,
  DatePipe,
  JsonPipe,
  NgClass,
  NgFor,
  NgIf,
  NgStyle,
} from '@angular/common';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';

import * as bootstrap from 'bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LazyLoadEvent } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { HighlightDirective } from '../../../_directives/highlight.directive';
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { user_privilege } from '../../../../_model/user_privilege';
import { search_filter } from '../../../../_model/search_fliter';
import { DatasearchService } from '../../../_services/datasearch.service';
import { AuthenticationService } from '../../../_services/authentication.service';
import { ConstantService } from '../../../_services/constant.service';
import { GlobalService } from '../../../_services/global.service';
import { ExportDataService } from '../../../_services/export-data.service';
import { BusyService } from '../../../_services/busy.service';
import * as $ from 'jquery';
import { CommanService } from '../../../_services/comman.service';
@Component({
  selector: 'app-quik-patent',
  standalone: true,
  imports: [
    JsonPipe,
    CommonModule,
    TableModule,
    CalendarModule,
    TooltipModule,
    NgIf,
    NgFor,
    NgClass,
    NgStyle,
    FormsModule,
    ReactiveFormsModule,
    HighlightDirective,
    DialogModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './quik-patent.component.html',
  styleUrl: './quik-patent.component.scss',
})
export class QuikPatentComponent {
  TableName: string = 'QUIK_PATENT_MONGO';
  pageTitile = 'QuikPatent';
  isSignedIn = false;
  tokenChecked = false;

  searchTypeOptions = [
    { type: 'Exact', label: 'Exact Search' },
    {
      type: 'Free',
      label: 'Free text search (Broad Search, it may take more time)',
    },
  ];
  searchOptions: any[] = [
    { name: 'Simple Search', value: 'SIMPLE' },
    { name: 'Advance Search', value: 'ADVANCE' },
    { name: 'Combination Search', value: 'COMBINATION' },
    // { name: "Claim / Example Search", value: "CLAIM" }
  ];
  claimSearchTypes: any[] = [
    {
      label: 'Independent Claim',
      value: 'independentClaim',
      field: 'independentClaim',
    },
    {
      label: 'Dependent Claim',
      value: 'dependentClaim',
      field: 'dependentClaim',
    },
    { label: 'Examples', value: 'Examples', field: 'dummy10' },
  ];
  combSearchBox = '';
  filteredProducts: any[] = [];
  // selectedSearchOption: any = { name: "Simple Search", value: "SIMPLE" };
  selectedSearchOption = 0;
  forms_initialized = false;
  filterForm_normal: FormGroup = new FormGroup({});
  filterForm_advanced: FormGroup = new FormGroup({});
  filterForm_combination: FormGroup = new FormGroup({});
  filterForm_claim: FormGroup = new FormGroup({});
  form_RaiseQuery: FormGroup = new FormGroup({});
  privilege_json!: user_privilege;
  TableRowsCounts: number[] = [5, 10, 20, 25, 50, 100, 150];
  Default_DownloadRec_Limit: number = 500;
  rows: number = 50;
  current_pagenumber: number = 1;
  user_data: any;
  cols: any[] = [];
  allCols: any[] = [];
  isFullScreen: boolean = false;
  columns: any[] = [];
  analysisDataKeys: any = [];
  loadingCompleted: boolean = false;
  pageLimitInPrivilegeJson: number = 0;
  pageLimitInDatabaseLimit: number = 0;
  // analysisDataKeys : any = [];
  querySuggestions: any = [
    { search_value: 'AND', columnName: 'AND', label: 'Operator' },
    { search_value: 'OR', columnName: 'OR', label: 'Operator' },
    { search_value: 'NOT', columnName: 'NOT', label: 'Operator' },
    {
      search_value: 'EQUAL TO',
      columnName: 'EQUAL TO',
      label: 'Date Operator',
    },
    {
      search_value: 'NOT EQUAL TO',
      columnName: 'NOT EQUAL TO',
      label: 'Date Operator',
    },
    { search_value: 'BETWEEN', columnName: 'BETWEEN', label: 'Date Operator' },
    {
      search_value: 'NOT BETWEEN',
      columnName: 'NOT BETWEEN',
      label: 'Date Operator',
    },
    { search_value: '(term)', columnName: '(term)', label: 'Field Text' },
    {
      search_value: '(term1 AND term2)',
      columnName: '(term1 AND term2)',
      label: 'Field Text',
    },
    {
      search_value: '(term1 OR term2)',
      columnName: '(term1 OR term2)',
      label: 'Field Text',
    },
    {
      search_value: '(dd-mm-yyyy TO *)',
      columnName: '(dd-mm-yyyy TO *)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
  ];
  matchModeOptions: any = [
    { label: 'Select Filter', value: 'select' },
    { label: 'Date is', value: 'dateIs' },
    { label: 'Date is not', value: 'dateIsNot' },
    { label: 'Date is before', value: 'dateBefore' },
    { label: 'Date is after', value: 'dateAfter' },
  ];
  detailViewTabs = [
    { header: 'BIBLIOGRAPHY', field: '' },
    { header: 'DESCRIPTION', field: 'description' },
    { header: 'CLAIMS', field: 'claims' },
    { header: 'PATENT FAMILY', field: 'patentFamily' },
    { header: 'SUPPLEMENTARY PROTECTION CERTIFICATE (SPC)', field: 'spc' },
    { header: 'ORANGE BOOK (OB) PATENTS', field: 'dummy2' },
  ];
  selectedDetailViewIndex = 0;
  searchType = 'exact';
  patentTypes: any[] = [];
  addOnPatentTypes: any[] = [];
  isShowQueryBox: boolean = false;
  isShowAccessDialog: boolean = false;
  IsFilterAplied: boolean = false;
  analysisApi: boolean = false;
  isQueryOptionSelected: boolean = false;
  IsSuggestedItemClick: boolean = false;
  isShowTable: boolean = false;
  isQueryErrorFound: boolean = false;
  isShowReadMoreDialog: boolean = false;
  initializedForm: boolean = false;
  isListView: boolean = true;
  isShowRaiseQuery: boolean = false;
  is_show_Total_Search_Exceed_popup: boolean = false;
  is_show_Search_Priv_popup: boolean = false;
  is_show_Daily_Search_Exceed_popup: boolean = false;
  is_show_Download_Priv_popup: boolean = false;
  is_show_Daily_Download_Exceed_popup: boolean = false;
  is_show_Total_Download_Exceed_popup: boolean = false;
  productDetails: boolean = false;
  analysisView: boolean = false;
  isValidQueryCondition: boolean = true;
  currentFilterCondition: any = [];
  currentSortBy: string = '';
  application_query: string = '';
  search_filters!: search_filter;
  user_ip: string = '';
  address: string = '';
  additionalOperator: string = '';
  products_current_datasource: any[] = [];
  analysisFilterVal: any = [];
  rptDataForExcel: any = [];
  textsearch = '';
  searchedWords: string[] = [];
  searchFields = ['product', 'combination'];
  searchQueryGrid: string = '';
  SuggestedDbColumn: string = '';
  SuggestedDbField: string = '';
  dynSelectedPatentType: string = '';
  lastSearchQuery: string = '';
  readMoreColumn: string = '';
  readMoreContent: string = '';
  dateValue: any = {};
  tablefilter: any = {};
  analysisData: any = {};
  detailViewData: any = {};
  totalRecords: any;
  isShowAutoSearch: boolean = false;
  isLoadAutoSearch: boolean = false;
  updatePrivilege = false;
  loading_table = false;
  first = 0;
  oldResult: any = {};
  oldSearchQueryGrid = '';
  listSortByfield: string = '';
  listSortOrder: string = 'ASC';
  colCntAutoSearch: number = 0;
  results_suggestion: any[] = [];
  public searchTerms = new Subject<string>();
  postdata: any = {
    mode: 'GET_AUTO_SUGGEST',
  };
  searchCondition: any = {};
  isDataExistsAutoSearch: boolean = true;
  dropdownSuggestions: any = [];
  operatorSelected: string = '';
  fieldSelected: string = '';
  matchText: string = '';
  searchValueFromEmail: string | null = null;
  regex_query =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  // search_regex_query = /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>(?:[^(]+|\([^)]*\))*)\)/g;
  search_regex_query =
    /\s*(?<operator>AND|OR|NOT)?\s*(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\s*\((?<value>[^()]*?(?:\s+TO\s+[^()]*?)?)\)\s*/g;
  regex_query1 =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  regex_query2 = /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+)/gi;

  receivedData: any = null;
  current_GBRN: any = 0;
  current_Active_Ingredient: any = 0;
  constructor(
    private datasearch: DatasearchService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private globalService: GlobalService,
    private fb: FormBuilder,
    private exportdataService: ExportDataService,
    private datePipe: DatePipe,
    private busyService: BusyService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private commanService: CommanService,
    private router: Router
  ) {
    this.setIpandLocation();
    this.renderer.listen('document', 'click', (event: MouseEvent) => {
      this.handleDocumentClick(event);
    });
  }

  ngOnInit() {
    this.filterForm_normal = this.fb.group({
      ddlpatenttype: ['gbrn'], // Set default to GBRN
      search_type_simple: ['Exact', Validators.required],
      textautocomplete: ['', Validators.required],
    });

    // 2. Subscribe to GBRN from RxJS
    this.commanService.current_Active_Ingredient.subscribe(
      (activeIngredient_res: any) => {
        if (activeIngredient_res) {
          this.current_Active_Ingredient = activeIngredient_res;
          // console.log(
          //   'gbrn  from rxjs to quik',
          //   this.current_Active_Ingredient
          // );

          // 3. Delay patching slightly to ensure form is initialized properly
          setTimeout(() => {
            if (
              this.filterForm_normal &&
              this.filterForm_normal.get('textautocomplete')
            ) {
              this.filterForm_normal.patchValue({
                textautocomplete: this.current_Active_Ingredient,
              });
            } else {
              console.error(
                'filterForm_normal or textautocomplete control is not initialized.'
              );
            }

            this.search(); // Call search after patching
          });
        } else {
          console.warn('No active ingredient received from service.');
        }
      }
    );
    this.commanService.getUserPrivilege().subscribe((res: any) => {
      this.privilege_json = res;
      console.log('privaleges json in large screen ', this.privilege_json);
    });
    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      this.user_data = val;
      this.loadColumnDetails();
    });
    this.loadSearchCols();
    // this.getUserPrivilege();
    this.loadTableConfig();
    this.loadPatents();
    // this.route.queryParams.subscribe((params) => {
    //   const findParam = params['find'];
    //   if (findParam) {
    //     this.searchValueFromEmail = decodeURIComponent(findParam).replace(
    //       /%20/g,
    //       ' '
    //     );
    //     if (this.searchValueFromEmail) {
    //       this.isShowTable = true;
    //       this.searchQueryGrid = this.searchValueFromEmail;
    //       this.filterForm_normal
    //         .get('textautocomplete')
    //         ?.setValue('Chlorantraniliprole');
    //       // this.searchQuery();
    //       setTimeout(() => {
    //         this.searchQuery();
    //         this.router.navigateByUrl("/search");
    //       }, 1000);
    //     }
    //   }
    // });

    this.globalService.sendMenuIndex(1);
    this.initializeForm();
    // this.globalService.getSearchCondition().subscribe((data)=>{
    //   this.staticSuggestion('keyword', '', data);
    // });

    // Auto complete manage
    this.searchTerms
      .pipe(debounceTime(1000))
      .pipe(distinctUntilChanged())
      .subscribe((searchvalue) => {
        this.searchCondition = {};
        if (searchvalue != '') {
          this.searchFields = this.columns
            .filter((col) => {
              return this.searchFields.indexOf(col.tableColumnName) >= 0;
            })
            .map((val) => {
              return val.tableColumnName;
            });
          let searchWordArr = searchvalue.split(/[^\w\s]/gi);
          this.searchFields.forEach((field) => {
            if (!this.searchCondition.hasOwnProperty(field)) {
              this.searchCondition[field] = [];
            }
            searchWordArr.forEach((text) => {
              this.searchCondition[field].push({
                [field]: { $regex: text, $options: 'i' },
              });
            });
          });
          this.postdata = {
            mode: 'GET_AUTO_SUGGEST',
            searchCondition: this.searchCondition,
            pagenumber: 1,
            rowscount: 10,
          };
          this.datasearch.quik_patent_dropdown(this.postdata).subscribe(
            (res) => {
              let datasearch: any = [];
              res.forEach((searchValue: any) => {
                let valArr = searchValue.search_value.split(/[;+]/);
                valArr.forEach((val: any) => {
                  if (
                    val
                      .toLowerCase()
                      .indexOf(
                        this.filterForm_normal.controls[
                          'textautocomplete'
                        ].value.toLowerCase()
                      ) != -1
                  ) {
                    datasearch.push({
                      search_value: val,
                      columnname: searchValue.columnname,
                      label: searchValue.label,
                    });
                  }
                });
              });
              const unique = datasearch.filter((obj: any, index: any) => {
                return (
                  index ===
                  datasearch.findIndex(
                    (o: any) =>
                      obj.search_value === o.search_value &&
                      obj.columnname === o.columnname
                  )
                );
              });
              datasearch = unique;
              this.results_suggestion = datasearch;
              this.colCntAutoSearch =
                this.results_suggestion.length > 0 ? 1 : 0;

              this.isDataExistsAutoSearch = this.results_suggestion.length > 0;
              this.isLoadAutoSearch = false;
            },
            (error) => {
              // this.toastr.error('Something went wrong..Please try again!');
            }
          );
        }
      });

    this.getKeywordList();

    // This method get page limit data for XIM Activepatent
    this.datasearch
      .GetDatabasePageLimit({
        database: 'AgroPat Ultimate Discovery Suite Beta',
      })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
          } else {
            console.log('Error success false');
          }
        },
        (error: any) => {
          console.log('Error :', error);
        }
      );
  }

  /////////////// Search by email ////////////////
  searchByEmail() {
    this.route.queryParams.subscribe((params) => {
      const encodedData = params['emailsearch'];
      if (encodedData) {
        this.receivedData = JSON.parse(decodeURIComponent(encodedData));
        let searchType = this.receivedData.searchType;
        switch (searchType) {
          case 'Simple':
            this.selectedSearchOption = 0;
            if (this.filterForm_normal) {
              this.filterForm_normal.setValue(this.receivedData.searchValue);
            }
            break;
          case 'Advance':
            this.selectedSearchOption = 1;
            if (this.filterForm_normal) {
              this.filterForm_advanced.setValue(this.receivedData.searchValue);
            }
            break;
          case 'Combination':
            this.selectedSearchOption = 2;
            if (this.filterForm_normal) {
              this.filterForm_combination.setValue(
                this.receivedData.searchValue
              );
            }
            break;
          default:
            console.log('Not preset');
        }
        this.busyService.busy();
        setTimeout(() => {
          this.router.navigateByUrl('/search');
          this.search();
          this.busyService.idle();
        }, 2000);
      }
    });
  }

  openSignInForm() {
    this.globalService.sendOpenSignInModal(true);
    // console.log("")
  }
  openSignUpForm() {
    this.globalService.sendOpenSignUpModal(true);
    // console.log("")
  }

  initializeForm() {
    //Normal Form
    this.filterForm_normal = this.fb.group({
      ddlpatenttype: ['PRODUCT'],
      search_type_simple: ['Exact', Validators.required],
      textautocomplete: ['', Validators.required],
    });

    // Advance Form
    this.filterForm_advanced = this.fb.group({
      ddlpatenttype: [''],
      search_type_advance: ['Exact', Validators.required],
      advfilters: this.fb.array([
        this.fb.group({
          ddloprator: new FormControl('AND', [Validators.required]),
          ddlfieldnameadv: new FormControl('select', [Validators.required]),
          txtfiltervalue: new FormControl('', [Validators.required]),
        }),
        this.fb.group({
          ddloprator: new FormControl('AND', [Validators.required]),
          ddlfieldnameadv: new FormControl('select', [Validators.required]),
          txtfiltervalue: new FormControl('', [Validators.required]),
        }),
        this.fb.group({
          ddloprator: new FormControl('AND', [Validators.required]),
          ddlfieldnameadv: new FormControl('select', [Validators.required]),
          txtfiltervalue: new FormControl('', [Validators.required]),
        }),
      ]),
    });

    // Combination Form
    this.filterForm_combination = this.fb.group({
      txtcombination_patenttype: [''],
      search_type_combination: ['Exact', Validators.required],
      txtcombination_1: [''],
      txtcombination_2: [''],
      txtcombination_3: [''],
      txtcombination_4: [''],
      txtcombination_5: [''],
    });

    // Claim Form
    this.filterForm_claim = this.fb.group({
      ddlfieldnameclaim: [''],
      txtclaim_1: [''],
      txtclaim_2: [''],
      txtclaim_3: [''],
      txtclaim_4: [''],
      txtclaim_5: [''],
      txtclaim_patenttype: [''],
    });

    this.form_RaiseQuery = this.fb.group({
      txtResponseEmail: ['', Validators.required],
      txtQuery: ['', Validators.required],
    });
    this.initializedForm = true;
  }

  get advfilters(): FormArray {
    return this.filterForm_advanced.controls['advfilters'] as FormArray;
  }

  addFilter() {
    const advfilterForm = this.fb.group({
      ddloprator: new FormControl('AND', [Validators.required]),
      ddlfieldnameadv: new FormControl('select', [Validators.required]),
      txtfiltervalue: new FormControl('', [Validators.required]),
    });
    this.advfilters.push(advfilterForm);
  }

  deleteFilter(advfilterIndex: number) {
    this.advfilters.removeAt(advfilterIndex);
  }

  // async getUserPrivilege(): Promise<void> {
  //   this.authentication.getCurrentUserValue().subscribe((val: any) => {
  //     console.log('[getUserPrivilege] - Current user data received:', val);

  //     this.user_data = val;

  //     // ✅ Get stored privileges from localStorage
  //     const storedPrivileges = JSON.parse(
  //       localStorage.getItem('user_privilege') || '{}'
  //     );

  //     if (!storedPrivileges || Object.keys(storedPrivileges).length === 0) {
  //       console.warn(
  //         '[getUserPrivilege] - No user_privilege found in localStorage.'
  //       );
  //       return;
  //     }

  //     // ✅ App key for agropat privilege
  //     const appKey = 'agropat-ultimate-discovery-suite-beta';
  //     const privilegeData = storedPrivileges[appKey];

  //     if (!privilegeData) {
  //       console.warn(
  //         `[getUserPrivilege] - No privilege found for app: ${appKey}`
  //       );
  //       return;
  //     }

  //     console.log(
  //       `[getUserPrivilege] - Fetched privilege data for ${appKey}:`,
  //       privilegeData
  //     );

  //     // ✅ Store locally for this component
  //     this.privilege_json = privilegeData;

  //     // ✅ Push privilege data to CommanService (Reactive access)
  //     this.commanService.currentPrivilege.next(this.privilege_json);

  //     console.log(
  //       `[getUserPrivilege] - Privilege JSON pushed to commanService for ${appKey}.`
  //     );
  //   });
  // }

  saveColumnDetails() {
    const postdata = {
      userId: this.user_data?.userId || this.user_data?.userid,
      columns: this.allCols.map(col => ({
        field: col.field,
        isDisplay: col.isDisplay === 1 || col.isDisplay === true,
        columnWidth: typeof col.columnWidth === 'number' ? col.columnWidth + 'px' : col.columnWidth,
        displayOrder: col.displayOrder
      })),
      tableName: "templatequikpatentmongos"
    };

    this.busyService.busy();
    this.datasearch.save_quik_patent_column_config(postdata).subscribe(
      (res) => {
        if (res.status) {
          this.closeFieldsSettingModal();
          this.loadColumnDetails(); // Reload columns after save
        }
      },
      (error) => {
        console.error("Error saving column configuration:", error);
      },
      () => {
        this.busyService.idle();
      }
    );
  }

  closeFieldsSettingModal() {
    // debugger;
    const modalElement = document.getElementById('field_setting_modal');
    if (modalElement) {
      // Remove the 'show' class and set the display style
      modalElement.classList.remove('show');
      modalElement.setAttribute('style', 'display: none;'); // Set the display style
      modalElement.setAttribute('aria-hidden', 'true');

      // Get the Bootstrap modal instance
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        modalInstance.dispose();
      }

      // Allow body to scroll again
      document.body.classList.remove('modal-open'); // Remove the modal-open class
      document.body.style.overflow = ''; // Reset overflow to default
    }
  }

  loadTableConfig() {
    let postdata = {
      tablename: this.TableName,
    };
    this.datasearch.GetTemplateTableDtls(postdata).subscribe({
      next: (res) => {
        let data = res;
        this.Default_DownloadRec_Limit = data.Default_DownloadRec_Limit;
        this.TableRowsCounts.indexOf(data.Default_Grid_RowsCount) < 0
          ? this.TableRowsCounts.push(data.Default_Grid_RowsCount)
          : '';
        this.TableRowsCounts.sort((a, b) => {
          return a - b;
        });
        this.rows = data.Default_Grid_RowsCount;
      },
      error(err) {
        console.log(err);
      },
    });
  }

  loadColumnDetails() {
    const postdata = {
      userId: this.user_data?.userId || this.user_data?.userid
    };
    this.datasearch.quik_patent_column_config(postdata).subscribe(
      (res) => {
        if (res.status && res.data) {
          // Handle Table Columns
          if (res.data.results) {
            res.data.results.forEach((field: any) => {
              if (typeof field.columnWidth === 'string') {
                field.columnWidth = parseInt(
                  field.columnWidth.replace('px', '')
                );
              }
            });
            this.allCols = res.data.results;
            this.cols = [...this.allCols];
          }

          // Handle Dropdown Columns
          if (res.data.dropdownColumns) {
            this.columns = res.data.dropdownColumns.map((col: any) => {
              return {
                ...col,
                DisplayColumnName: col.displayColumnName, // for compatibility with existing code
                tableColumnName: col.tableColumnName,
              };
            });

            this.columns.sort((a: any, b: any) => {
              return a.DisplayColumnName.localeCompare(b.DisplayColumnName);
            });

            this.querySuggestions = this.querySuggestions.filter(
              (item: any) => item.label !== 'Field'
            );

            this.columns.forEach((col: any) => {
              if (!this.existingValues[col.tableColumnName]) {
                this.querySuggestions.push({
                  search_value: col.tableColumnName,
                  columnName: col.DisplayColumnName,
                  label: 'Field',
                  fieldDataType: col.fieldDataType,
                });
                this.existingValues[col.tableColumnName] = true;
              }
            });

            if (!this.existingValues['patentType']) {
              this.querySuggestions.push({
                search_value: 'patentType',
                columnName: 'PATENT TYPE',
                label: 'Field',
              });
              this.existingValues['patentType'] = true;
            }
          }
        }
      },
      (error) => {}
    );
  }

  private existingValues: { [key: string]: boolean } = {};

  loadSearchCols() {
    let postdata = {
      tablename: 'TEMPLATE_' + this.TableName,
    };
    this.datasearch.GetTemplateCols(postdata).subscribe((res) => {
      this.columns = res.data;
      this.columns.sort((a: any, b: any) => {
        return a.DisplayColumnName.localeCompare(b.DisplayColumnName);
      });
      this.columns.forEach((col) => {
        if (!this.existingValues[col.tableColumnName]) {
          this.querySuggestions.push({
            search_value: col.tableColumnName,
            columnName: col.DisplayColumnName,
            label: 'Field',
            fieldDataType: col.fieldDataType,
          });
          this.existingValues[col.tableColumnName] = true;
        }
      });
      if (!this.existingValues['patentType']) {
        this.querySuggestions.push({
          search_value: 'patentType',
          columnName: 'PATENT TYPE',
          label: 'Field',
        });
        this.existingValues['patentType'] = true;
      }
    });
  }

  //load patents
  loadPatents() {
    this.datasearch.quik_patent_types().subscribe((res) => {
      if (res.success && res.data?.length) {
        const allTypes = res.data.map((col: any) => ({
          patentType: col.patent_type,
          colour_code: col.colour_code,
          labelType: col.labelType,
        }));

        // Store all types in patentTypes so they are visible as buttons and used for color lookup
        this.patentTypes = allTypes;

        // Addon types → filtered separately if needed elsewhere
        this.addOnPatentTypes = allTypes.filter(
          (col: any) => col.labelType === 'addon'
        );

        // Populate query suggestions for search
        allTypes.forEach((col: any) => {
          this.querySuggestions.push({
            search_value: col.patentType,
            columnName: col.patentType,
            label: 'Patent Type',
            fieldDataType: 'text',
          });
        });
      }
    });
  }

  getLabelList() {
    let searchCondition = this.getLabelCondition();
    let countCondition = this.getLabelCondition();
    let postdata = {
      tableName: 'TABLE_LABELS',
      condition: searchCondition,
      countCondition: countCondition,
    };

    this.datasearch.getlabel(postdata).subscribe((res: any) => {
      let response: any = res.result.data;
      this.patentTypes = JSON.parse(
        JSON.stringify(
          response.map((val: any) => {
            return {
              patentType: val.searchText,
              colour_code: val.colourCode,
              labelType: val.labelType,
            };
          })
        )
      );
      // this.patentTypes = JSON.parse(JSON.stringify(response.filter(patent=> patent.labelType === 'Main').map(val=>{return { patentType: val.searchText, colour_code: val.colourCode }})));
      // this.patentTypes.push({ patentType: 'All', colour_code: '' });
      this.addOnPatentTypes = JSON.parse(
        JSON.stringify(
          response
            .filter((patent: any) => patent.labelType === 'AddOn')
            .map((val: any) => {
              return {
                patentType: val.searchText,
                colour_code: val.colourCode,
              };
            })
        )
      );
    });
  }

  getLabelCondition() {
    let condition = [];
    let match = [];
    match.push({
      tableId: '64f1c55ca59f3a107fba4ac5',
    });
    match.push({
      isActive: true,
    });
    condition.push({ $match: { $and: match } });
    return condition;
  }

  showReadMore(column: any, content: any) {
    this.isShowReadMoreDialog = true;
    this.readMoreColumn = column;
    this.readMoreContent = content.replace(/;/gi, '; ');
    this.readMoreContent = this.readMoreContent.replace(/\n|\r\n/gm, '<br/>');
    const modalElement = document.getElementById('read_more_modal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();
      }
    }
  }

  hideReadMore() {
    const modalElement = document.getElementById('read_more_modal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
  }

  getKeywordList(searchQuery?: string) {
    this.busyService.busy();
    // Using the new POST API with search text
    this.datasearch.getKeywordList(searchQuery).subscribe(
      (res: any) => {
        this.busyService.idle();
        if (res && res.data) {
          this._constant.sendKeywordList(
            res.data.map((data: any) => {
              data.description = this.formatText(data.description);
              // Map 'keywords' from the new API to 'keyword' as expected by the frontend
              return { keyword: data.keywords, description: data.description };
            })
          );
          // Populate searchedWords so that appHighlight directive can highlight them
          this.searchedWords = res.data.map((data: any) => data.keywords);
        }
      },
      (errorobj: any) => {
        this.busyService.idle();
      }
    );
  }

  formatText(content: any) {
    content = content.replace(/;/gi, '; ');
    content = content.replace(/\n|\r\n/gm, '<br/>');
    return content;
  }

  getSearchCondition() {
    let condition = [];
    let match: any = {};
    match.isActive = true;
    match.tables = {
      $elemMatch: { $eq: '64f1c55ca59f3a107fba4ac5' },
    };
    condition.push({ $match: match });
    return condition;
  }

  getCountCondition() {
    let condition: any = {};
    condition.isActive = true;
    condition.tables = {
      $elemMatch: { $eq: '64f1c55ca59f3a107fba4ac5' },
    };
    return condition;
  }

  getPatentNumber(data: any) {
    let regex_patent = /[A-Z]{2}\d{4,10}/gi;
    if (regex_patent.test(data)) {
      return data.match(regex_patent);
    } else {
      return data;
    }
  }

  sortBydata() {
    if (this.listSortByfield) {
      this.currentSortBy = `${this.listSortByfield} ${this.listSortOrder}`;
      this.searchData();
    }
  }

  loadProducts(event: any) {
    this.updatePrivilege = false;

    this.oldResult = {
      products_current_datasource: this.products_current_datasource,

      totalRecords: this.totalRecords,
      searchQueryGrid: this.oldSearchQueryGrid,
    };
    this.loading_table = true;
    this.current_pagenumber = event.first / event.rows + 1;

    // This condition ensures that user not see next page of their defind page limit
    this.handlePageLimit();
    if (this.pageLimitInPrivilegeJson) {
      if (this.current_pagenumber > this.pageLimitInPrivilegeJson) {
        this.messageService.add({
          severity: 'error',
          detail: 'You only see ' + this.pageLimitInPrivilegeJson + ' pages',
        });
        this.loading_table = false;
        return;
      }
    } else if (this.pageLimitInDatabaseLimit) {
      if (this.current_pagenumber > this.pageLimitInDatabaseLimit) {
        this.messageService.add({
          severity: 'error',
          detail: 'You only see ' + this.pageLimitInDatabaseLimit + ' pages',
        });
        this.loading_table = false;
        return;
      }
    }

    Object.keys(this.dateValue).forEach((dateFilter) => {
      if (
        event.filters &&
        event.filters[dateFilter][0].matchMode === 'contains'
      ) {
        this.dateValue[dateFilter] = null;
        event.filters[dateFilter][0].value = this.dateValue[dateFilter];
      } else {
        event.filters[dateFilter][0].value = this.dateValue[dateFilter];
      }
    });
    this.tablefilter = event.filters;
    this.first = event.first;
    //SORT BY CONDITION
    if (event.sortField && this.isListView) {
      this.currentSortBy = `${event.sortField} ${
        event.sortOrder == 1 ? 'ASC' : 'DESC'
      }`;
    } else if (!this.isListView && this.listSortByfield) {
      this.currentSortBy = `${this.listSortByfield} ${this.listSortOrder}`;
    } else {
      this.currentSortBy = '';
    }
    setTimeout(() => {
      this.searchData();
    });
  }

  filterClass(col: any) {
    if (Object.keys(this.tablefilter).length > 0) {
      if (col.fieldDataType === 'text') {
        if (
          this.tablefilter[col.field].matchMode === 'contains' &&
          !this.tablefilter[col.field].value
        ) {
          return '';
        } else {
          return 'filter-stl';
        }
      } else {
        if (
          this.tablefilter[col.field][0].matchMode === 'contains' &&
          !this.tablefilter[col.field][0].value
        ) {
          return '';
        } else {
          return 'filter-stl';
        }
      }
    } else {
      return '';
    }
  }
  addDataSpace(data: any) {
    return data != null ? data.toString().replace(/;/gi, '; ') : data;
  }

  filterDate(event: any, field: string) {
    this.dateValue[field] = event;
  }

  patentClass(patentType: any) {
    let patentArr = patentType.split(' ').filter((patent: any) => {
      return patent.toLowerCase() !== 'patent';
    });

    for (let i = 0; i < patentArr.length; i++) {
      for (let j = 0; j < this.patentTypes.length; j++) {
        if (!patentArr[i]) {
          return '';
        } else if (
          this.patentTypes[j].patentType.search(
            new RegExp(patentArr[i], 'i')
          ) >= 0
        ) {
          return this.patentTypes[j].colour_code;
        }
      }
    }
  }

  showDetailView(detailView: any) {
    this.productDetails = detailView;
    this.detailView(this.products_current_datasource[0]);
  }

  detailView(rowData: any) {
    this.detailViewData = rowData;
    if (this.detailViewData.claims) {
      this.detailViewData.claims = this.detailViewData.claims.replace(
        /;/gi,
        '; '
      );
      this.detailViewData.claims = this.detailViewData.claims.replace(
        /\n|\r\n/gm,
        '<br/>'
      );
    }
    if (this.detailViewData.description) {
      this.detailViewData.description = this.detailViewData.description.replace(
        /;/gi,
        '; '
      );
      this.detailViewData.description = this.detailViewData.description.replace(
        /\n|\r\n/gm,
        '<br/>'
      );
    }
    if (this.detailViewData.dummy2) {
      this.detailViewData.dummy2 = this.detailViewData.dummy2.replace(
        /;/gi,
        '; '
      );
      this.detailViewData.dummy2 = this.detailViewData.dummy2.replace(
        /\n|\r\n/gm,
        '<br/>'
      );
    }

    // console.log('000000000', this.detailViewData);
  }

  loadAutosearch() {
    this.isLoadAutoSearch = true;
    this.colCntAutoSearch = 0;
    this.results_suggestion = [];
    let len =
      this.filterForm_normal.controls['textautocomplete'].value.trim().length;
    this.isShowAutoSearch = len > 2 ? true : false;
    if (len > 2) {
      let searchvalue =
        this.filterForm_normal.controls['textautocomplete'].value.trim();
      this.searchTerms.next(searchvalue);
    } else {
      this.searchTerms.next('');
    }
  }

  filteProducts(event: any, formName: string) {
    this.combSearchBox = formName;
    let query = event.target.value;
    let searchCondition: any = [];
    let searchWordArr = query.split(/[^\w\s]/gi);
    this.filteredProducts = [];
    searchWordArr.forEach((text: any) => {
      if (text.length > 3) {
        searchCondition.push({ product: { $regex: text, $options: 'i' } });
      }
    });
    if (searchCondition.length) {
      let postdata = {
        mode: 'GET_PRODUCTS',
        searchCondition: searchCondition,
        search_keyword: query,
        pagenumber: 1,
        rowscount: 30,
        groupBy: 'product',
      };
      this.datasearch
        .quik_patent_combination_dropdown(postdata)
        .subscribe((res) => {
          let proddatatemp: any[] = [];
          res.forEach((searchValue: any) => {
            let valArr = searchValue.fieldValue.split(/[;+]/);
            valArr.forEach((val: any) => {
              if (
                val
                  .toLowerCase()
                  .indexOf(
                    this.filterForm_combination.controls[
                      formName
                    ].value.toLowerCase()
                  ) != -1
              ) {
                proddatatemp.push({ product_name: val });
              }
            });
          });
          const unique = proddatatemp.filter((obj, index) => {
            return (
              index ===
              proddatatemp.findIndex((o) => obj.product_name === o.product_name)
            );
          });
          proddatatemp = unique;
          this.filteredProducts = proddatatemp;
        });
    }
  }

  selectCombSuggestion(product_name: any, formName: string) {
    this.combSearchBox = '';
    this.filteredProducts = [];
    this.filterForm_combination.controls[formName].setValue(product_name);
    // console.log(this.filterForm_combination);
  }

  validateQuery(event: any) {
    let queryvalue = event.target.value;
    queryvalue = queryvalue.trim();

    //replace more than one space
    queryvalue = queryvalue.replace(/\s{2,}/gm, '');
    this.searchQueryGrid = queryvalue;

    let matches_conditions: any = [];
    let match_query: any = [];

    [...queryvalue.matchAll(this.regex_query1)].forEach((queryGroup) => {
      match_query.push(queryGroup[0]);
      matches_conditions.push(queryGroup.groups);
    });
    let matched_string = match_query.join('');
    if (this.searchQueryGrid) {
      this.isValidQueryCondition = queryvalue.length == matched_string.length;
    } else {
      this.isValidQueryCondition = false;
      return;
    }
    let endString = this.searchQueryGrid.slice(matched_string.length);
    let endCondArr: any = [];
    let match;
    while ((match = this.regex_query2.exec(endString)) !== null) {
      if (match.groups) {
        endCondArr.push({
          operator: match.groups['operator'],
          columnname: match.groups['columnname'],
        });
      }
    }

    if (
      this.searchQueryGrid.lastIndexOf(')') >
        this.searchQueryGrid.lastIndexOf('(') &&
      this.searchQueryGrid.lastIndexOf('(') >
        this.searchQueryGrid.lastIndexOf(':')
    ) {
      if (endCondArr.length === 0) {
        this.operatorSelected = 'no operator';
        this.isShowQueryBox = true;
        this.matchText = '';
        this.dropdownSuggestions = this.querySuggestions.filter((item: any) => {
          return item.label === 'Operator';
        });
      } else if (!endCondArr[0].operator) {
        this.matchText = endCondArr[0].columnname;
        if (endCondArr[0].columnname.length > 3) {
          this.isShowQueryBox = true;
          this.operatorSelected = 'wrong operator';
          this.dropdownSuggestions = [];
        } else if (endCondArr[0].columnname) {
          this.isShowQueryBox = true;
          if (
            endCondArr[0].columnname.toUpperCase() === 'AND' ||
            endCondArr[0].columnname.toUpperCase() === 'OR' ||
            endCondArr[0].columnname.toUpperCase() === 'NOT'
          ) {
            this.operatorSelected = 'operator';
            this.searchQueryGrid = this.searchQueryGrid.slice(
              0,
              this.searchQueryGrid.lastIndexOf(')') + 1
            );
            this.searchQueryGrid += ' ' + this.matchText.toUpperCase() + ' ';
            this.dropdownSuggestions = this.querySuggestions.filter(
              (item: any) => {
                return item.label === 'Field';
              }
            );
          } else {
            this.isShowQueryBox = true;
            this.dropdownSuggestions = this.querySuggestions.filter(
              (item: any) => {
                return this.matchText
                  ? item.label === 'Operator' &&
                      item.columnName
                        .toLowerCase()
                        .lastIndexOf(this.matchText.toLowerCase()) >= 0
                  : item.label === 'Operator';
              }
            );
            this.operatorSelected =
              this.dropdownSuggestions.length > 0
                ? 'no operator'
                : 'wrong operator';
          }
        }
      } else if (endCondArr[0].operator) {
        this.isShowQueryBox = true;
        this.matchText = endCondArr[0].columnname;
        this.operatorSelected = 'operator';
        this.searchQueryGrid = this.searchQueryGrid.slice(
          0,
          this.searchQueryGrid.lastIndexOf(')') + 1
        );
        this.searchQueryGrid +=
          ' ' +
          endCondArr[0].operator.toUpperCase() +
          ' ' +
          endCondArr[0].columnname;
        this.dropdownSuggestions = this.querySuggestions.filter((item: any) => {
          return this.matchText
            ? item.label === 'Field' &&
                item.columnName
                  .toLowerCase()
                  .lastIndexOf(this.matchText.toLowerCase()) >= 0
            : item.label === 'Field';
        });
        this.fieldSelected =
          this.dropdownSuggestions.length > 0 ? 'no field' : 'wrong field';
      }
    } else if (
      this.searchQueryGrid.lastIndexOf(')') >
        this.searchQueryGrid.lastIndexOf('(') &&
      this.searchQueryGrid.lastIndexOf(':') >
        this.searchQueryGrid.lastIndexOf(')')
    ) {
      if (endCondArr.length === 0) {
        this.operatorSelected = 'select operator';
        this.fieldSelected = 'select field';
        this.isShowQueryBox = true;
        this.dropdownSuggestions = [];
        this.matchText = '';
      } else if (!endCondArr[0].operator) {
        if (endCondArr[0].columnname === ' ') {
          this.operatorSelected = 'select operator';
          this.fieldSelected = 'select field';
          this.isShowQueryBox = true;
          this.dropdownSuggestions = [];
          this.matchText = '';
        } else if (endCondArr[0].columnname.length > 3) {
          this.isShowQueryBox = true;
          let typedValue = this.querySuggestions.filter((item: any) => {
            return (
              item.label === 'Field' &&
              item.columnName.toLowerCase() ===
                endCondArr[0].columnname.toLowerCase()
            );
          });
          if (typedValue.length > 0) {
            this.operatorSelected = 'select operator';
            this.fieldSelected = 'field';
            this.searchQueryGrid = this.searchQueryGrid.slice(
              0,
              this.searchQueryGrid.lastIndexOf(')') + 1
            );
            this.searchQueryGrid += ' ' + typedValue[0].columnName + ':';
          } else {
            this.operatorSelected = 'select operator';
            this.fieldSelected = 'select field';
          }
          this.dropdownSuggestions = [];
        } else if (endCondArr[0].columnname) {
          this.isShowQueryBox = true;
          if (
            endCondArr[0].columnname.toUpperCase() === 'AND' ||
            endCondArr[0].columnname.toUpperCase() === 'OR' ||
            endCondArr[0].columnname.toUpperCase() === 'NOT'
          ) {
            this.operatorSelected = 'operator';
            this.fieldSelected = 'wrong field';
            this.searchQueryGrid = this.searchQueryGrid.slice(
              0,
              this.searchQueryGrid.lastIndexOf(')') + 1
            );
            this.searchQueryGrid +=
              ' ' + endCondArr[0].columnname.toUpperCase() + ' :';
            this.dropdownSuggestions = [];
          } else {
            this.operatorSelected = 'select operator';
            this.fieldSelected = 'select field';
            this.dropdownSuggestions = [];
          }
        }
      } else if (endCondArr[0].operator) {
        this.isShowQueryBox = true;
        this.matchText = '';
        this.operatorSelected = 'operator';
        this.searchQueryGrid = this.searchQueryGrid.slice(
          0,
          this.searchQueryGrid.lastIndexOf(')') + 1
        );
        let typedValue = this.querySuggestions.filter((item: any) => {
          return (
            item.label === 'Field' &&
            item.columnName.toLowerCase() ===
              endCondArr[0].columnname.toLowerCase()
          );
        });
        if (typedValue.length > 0) {
          this.fieldSelected = 'field';
          this.searchQueryGrid +=
            ' ' +
            endCondArr[0].operator.toUpperCase() +
            ' ' +
            typedValue[0].columnName +
            ':(';
          if (typedValue[0].columnName === 'PATENT TYPE') {
            this.dropdownSuggestions = this.querySuggestions.filter(
              (item: any) => {
                return item.label === 'Patent Type';
              }
            );
          } else {
            this.dropdownSuggestions = this.querySuggestions.filter(
              (item: any) => {
                return typedValue[0].fieldDataType === 'text'
                  ? item.label === 'Field Text'
                  : item.label === 'Field Date';
              }
            );
          }
        } else {
          this.fieldSelected = 'wrong field';
          this.searchQueryGrid +=
            ' ' +
            endCondArr[0].operator.toUpperCase() +
            ' ' +
            endCondArr[0].columnname +
            ':';
          this.dropdownSuggestions = [];
        }
      }
    } else if (
      this.searchQueryGrid.lastIndexOf(')') > 0 &&
      this.searchQueryGrid.lastIndexOf(')') <
        this.searchQueryGrid.lastIndexOf(':') &&
      this.searchQueryGrid.lastIndexOf(':') <
        this.searchQueryGrid.lastIndexOf('(')
    ) {
      if (endCondArr.length === 2) {
        this.matchText = endCondArr[1].columnname;
      } else {
        this.matchText = '';
      }
      if (endCondArr[0].columnname === 'PATENT TYPE') {
        this.dropdownSuggestions = this.querySuggestions.filter((item: any) => {
          return this.matchText
            ? item.label === 'Patent Type' &&
                item.columnName
                  .toLowerCase()
                  .lastIndexOf(this.matchText.toLowerCase()) >= 0
            : item.label === 'Patent Type';
        });
        this.isShowQueryBox = true;
        this.operatorSelected = 'operator';
        this.fieldSelected = 'field';
      } else {
      }
    } else {
      this.matchText = '';
      this.matchText = endCondArr[0].columnname.trim();
      if (this.searchQueryGrid.lastIndexOf(':') < 0) {
        this.dropdownSuggestions = this.querySuggestions.filter((item: any) => {
          return this.matchText
            ? item.label === 'Field' &&
                item.columnName
                  .toLowerCase()
                  .lastIndexOf(this.matchText.toLowerCase()) >= 0
            : item.label === 'Field';
        });
        this.isShowQueryBox = true;
        if (!this.dropdownSuggestions.length) {
          this.fieldSelected = 'wrong field';
        } else {
          this.fieldSelected = '';
        }
      } else {
        this.fieldSelected = '';
        this.dropdownSuggestions = this.querySuggestions.filter((item: any) => {
          return this.matchText
            ? item.label === 'Field' &&
                item.columnName
                  .toLowerCase()
                  .lastIndexOf(this.matchText.toLowerCase()) >= 0
            : item.label === 'Field';
        });
        if (this.dropdownSuggestions.length) {
          this.searchQueryGrid = this.dropdownSuggestions[0].columnName + ':(';
          this.matchText =
            endCondArr.length === 1 ? '' : endCondArr[1].columnname;
          if (this.dropdownSuggestions[0].columnName === 'PATENT TYPE') {
            this.dropdownSuggestions = this.querySuggestions.filter(
              (item: any) => {
                return this.matchText
                  ? item.label === 'Patent Type' &&
                      item.columnName
                        .toLowerCase()
                        .lastIndexOf(this.matchText.toLowerCase()) >= 0
                  : item.label === 'Patent Type';
              }
            );
            this.isShowQueryBox = true;
            this.operatorSelected = 'operator';
            this.fieldSelected = 'field';
          } else if (this.dropdownSuggestions[0].fieldDataType === 'date') {
            this.dropdownSuggestions = this.querySuggestions.filter(
              (item: any) => {
                return item.label === 'Field Date';
              }
            );
          } else {
            this.dropdownSuggestions = this.querySuggestions.filter(
              (item: any) => {
                return item.label === 'Field Text';
              }
            );
          }
        } else {
          this.fieldSelected = 'wrong field';
        }
      }
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.isShowQueryBox = false;
      this.dropdownSuggestions = [];
      this.isShowAutoSearch = false;
      this.results_suggestion = [];
      this.combSearchBox = '';
      this.filteredProducts = [];
    }
  }

  @ViewChild('inputQuery') inputQuery!: ElementRef;
  handleDocumentClick(event: MouseEvent) {
    this.isShowQueryBox = false;
    this.dropdownSuggestions = [];
    this.isShowAutoSearch = false;
    this.results_suggestion = [];
    this.combSearchBox = '';
    this.filteredProducts = [];
    if (this.inputQuery && this.inputQuery.nativeElement) {
      const inputElement = this.inputQuery.nativeElement;

      if (inputElement.contains(event.target)) {
        return;
      }
    }
  }

  getFieldType(fieldname: any) {
    return this.columns.find((item) => item.tableColumnName == fieldname)
      ?.fieldDataType;
  }

  autoQuerySelect(item: any) {
    if (item.label === 'Operator') {
      this.searchQueryGrid = this.searchQueryGrid.slice(
        0,
        this.searchQueryGrid.lastIndexOf(')') + 1
      );
      this.searchQueryGrid += ' ' + item.columnName + ' ';
      this.dropdownSuggestions = this.querySuggestions.filter((item: any) => {
        return item.label === 'Field';
      });
      this.operatorSelected = 'operator';
    } else if (item.label === 'Field') {
      this.isShowQueryBox = item.fieldDataType === 'date' ? true : false;
      this.searchQueryGrid = this.searchQueryGrid.trim();
      this.searchQueryGrid +=
        item.fieldDataType === 'text'
          ? ' ' + item.columnName + ':('
          : ' ' + item.columnName + ':';
      this.dropdownSuggestions =
        item.fieldDataType === 'date'
          ? this.querySuggestions.filter((item: any) => {
              return item.label === 'Date Operator';
            })
          : [];
      this.operatorSelected = 'field';
      this.additionalOperator = 'date';
    } else if (item.label === 'Date Operator') {
      this.dropdownSuggestions = [];
      this.searchQueryGrid = this.searchQueryGrid.slice(
        0,
        this.searchQueryGrid.lastIndexOf(':') + 1
      );
      this.isShowQueryBox = true;
      this.searchQueryGrid = this.searchQueryGrid.trim();
      this.searchQueryGrid += item.columnName + '(';
      this.additionalOperator = 'select date';
      this.operatorSelected = 'field';
    } else {
      this.isShowQueryBox = false;
      this.searchQueryGrid += item.columnName + '(';
    }
    const element = document.getElementById('inputSearchQuery');
    if (element) {
      element.focus();
    }
  }

  searchQuery() {
    // this.oldResult = {
    //   products_current_datasource: this.products_current_datasource,
    //   totalRecords: this.totalRecords,
    //   searchQueryGrid: this.oldSearchQueryGrid
    // }
    this.showAnalysisView(true);
    this.analysisView = false;
    this.isQueryOptionSelected = true;
    // this.isQueryOptionSelected=false;
    this.isQueryErrorFound = false;
    //replace more than one space
    this.searchQueryGrid = this.searchQueryGrid.replace(/\s{2,}/gm, '');
    this.lastSearchQuery = JSON.stringify(this.searchQueryGrid);
    this.searchData();
  }

  selectPatentType(patentType: any) {
    this.analysisFilterVal = [];

    // Check if the selected patent type is the same as the current one
    if (this.dynSelectedPatentType === patentType) {
      this.dynSelectedPatentType = ''; // Deselect it

      // Adjust the query to remove patent type conditions if it's deselected
      if (this.isQueryOptionSelected) {
        this.searchQueryGrid = this.searchQueryGrid.trim();
        let queryvalue: any = this.searchQueryGrid;
        queryvalue = queryvalue.replace(/\s{2,}/gm, ''); // Remove extra spaces
        this.searchQueryGrid = queryvalue;

        let matches_conditions: any = [];
        let match_query: any = [];

        // Remove 'PATENT TYPE' condition from the query
        [...queryvalue.matchAll(this.regex_query1)].forEach((queryGroup) => {
          match_query.push(queryGroup[0]);
          matches_conditions.push(queryGroup.groups);
        });
        matches_conditions.forEach((condition: any, index: any) => {
          if (condition.columnname === 'PATENT TYPE') {
            match_query.splice(index, 1); // Remove the matching patent type condition
          }
        });
        this.searchQueryGrid = match_query.join('');
      }
    } else {
      this.dynSelectedPatentType = patentType; // Set selected patent type

      // Modify the search query to include the selected patent type
      if (this.isQueryOptionSelected) {
        this.searchQueryGrid = this.searchQueryGrid.trim();
        let queryvalue: any = this.searchQueryGrid;
        queryvalue = queryvalue.replace(/\s{2,}/gm, ''); // Remove extra spaces
        this.searchQueryGrid = queryvalue;

        let matches_conditions: any = [];
        let match_query: any = [];

        // Modify the query to add PATENT TYPE
        [...queryvalue.matchAll(this.regex_query1)].forEach((queryGroup) => {
          match_query.push(queryGroup[0]);
          matches_conditions.push(queryGroup.groups);
        });
        matches_conditions.forEach((condition: any, index: any) => {
          if (condition.columnname === 'PATENT TYPE') {
            match_query.splice(index, 1); // Remove any existing PATENT TYPE condition
          }
        });
        this.searchQueryGrid = match_query.join('');
        this.searchQueryGrid += ` AND PATENT TYPE:(${this.dynSelectedPatentType})`; // Add the new condition
      }
    }

    // Update the filter condition to include patentType
    this.isListView = true;

    // Add the new patent type condition to the filter query
    let patentTypeCondition = {
      patentType: {
        $regex: `\\b${this.dynSelectedPatentType}\\b`,
        $options: 'i',
      },
    };

    // Add this condition to the filter
    if (this.dynSelectedPatentType) {
      this.currentFilterCondition.push(patentTypeCondition);
    }

    // Call searchData with updated query and filter conditions
    this.searchData(true);
  }

  analysisCardClass(val: any) {
    let valueSelected = false;
    this.analysisFilterVal.forEach((analysis: any) => {
      if (val === analysis.filter) {
        valueSelected = true;
      }
    });
    return valueSelected ? 'card-select' : '';
  }

  analysisRowClass(filter: any, val: any) {
    let valueSelected = false;
    this.analysisFilterVal.forEach((analysis: any) => {
      if (filter === analysis.filter && val === analysis.value) {
        valueSelected = true;
      }
    });
    return valueSelected ? 'analysis-row-select' : '';
  }

  analysisFilter(filter: any, analysisVal: any) {
    this.analysisFilterVal.push({ filter: filter, value: analysisVal });
    this.searchData();
    this.showAnalysisView(false);
  }

  removeAnalysisFilter(analysis: any) {
    this.analysisFilterVal = this.analysisFilterVal.filter((val: any) => {
      return analysis.filter !== val.filter;
    });
    this.searchData();
    this.showAnalysisView(false);
  }

  showAnalysisView(toggleView: boolean) {
    if (toggleView) {
      this.analysisView = !this.analysisView;
    }

    // Only call API if opening and data hasn't been fetched yet
    if (this.analysisView && !this.analysisApi) {
      this.analysisApi = true;
      this.busyService.busy();

      const { analysisFilters } = this.getFilterCondition();

      const postdata = {
        filterconditionQuikPatent: analysisFilters,
      };

      this.datasearch.quik_patent_analysis(postdata).subscribe(
        (response: any) => {
          this.analysisData = response.data;
          this.analysisDataKeys = Object.keys(this.analysisData);
        },
        (error) => {
          console.log(error);
          this.busyService.idle();
        },
        () => {
          this.busyService.idle();
        }
      );
    }
  }

  staticSuggestion(columnname: any, title: any, search_value: any) {
    switch (columnname) {
      case 'keyword':
        this.IsSuggestedItemClick = false;
        this.SuggestedDbColumn = '';
        this.filterForm_normal.controls['textautocomplete'].setValue(
          search_value
        );
        this.search();
        break;
      default:
        let searchItem = {
          columnname: columnname,
          field: title,
          search_value: search_value,
        };
        this.autoSearchSelect(searchItem);
        break;
    }
  }

  autoSearchSelect(searchItem: any) {
    this.IsSuggestedItemClick = true;
    this.SuggestedDbColumn = searchItem.columnname;
    this.SuggestedDbField = searchItem.field;
    this.filterForm_normal.controls['textautocomplete'].setValue(
      searchItem.search_value
    );
    this.search();
  }

  search() {
    // New
    this.updatePrivilege = true;

    this.results_suggestion = [];
    this.isShowAutoSearch = false;

    this.isShowTable = false;
    this.isQueryErrorFound = false;
    this.searchQueryGrid = '';
    this.searchData();
  }

  searchData(showDetailView?: boolean) {
    if (!this.current_Active_Ingredient) return;

    this.isShowQueryBox = false;

    // SIMPLE SEARCH check
    if (this.searchOptions[this.selectedSearchOption].value === 'SIMPLE') {
      if (!this.filterForm_normal?.controls['textautocomplete']?.value) return;
    }

    // ADVANCE SEARCH check
    else if (
      this.searchOptions[this.selectedSearchOption].value === 'ADVANCE'
    ) {
      let selectedAdvFilter = this.filterForm_advanced.value.advfilters.some(
        (f: any) => f.ddlfieldnameadv !== '' && f.txtfiltervalue !== ''
      );
    }
    const { criteria, filters, keywordSearchText } = this.getFilterCondition();
    let postdata = {
      search_type: this.searchType,
      criteria: criteria,
      pagenumber: this.current_pagenumber,
      rowscount: this.rows,
      sortby: this.currentSortBy || '',
      filters: filters,
      subFilters: {},

      activityObj: {
        userId: this.user_data.userid || '',
        privilegeName: 'quikpatent_search',
        mode: 'search',
        query: this.application_query || 'N/A',
        searchFilters: this.search_filters || 'N/A',
        userIp: this.user_ip || '',
        address: this.address || '',
      },

      product: this.current_Active_Ingredient,
    };
  this.busyService.busy();
    
    // Fetch updated keywords matching this search
    this.getKeywordList(keywordSearchText);
    
    this.datasearch.quik_patent_data(postdata).subscribe(
      (res) => {
        let response: any = res;
        if (response?.status == 'error') {
          return;
        }

        this.products_current_datasource = res.data.data;
        
        // Calculate S.No before hiding columns to ensure S_NO column is not removed
        this.products_current_datasource.forEach((row, index) => {
          row.S_NO = (this.current_pagenumber - 1) * this.rows + index + 1;
        });

        // Reset cols from allCols before hiding columns based on current data
        this.cols = [...this.allCols];
        this.hideColumnsBasedOnData();
        this.totalRecords = res.data.count;
        this.cols.forEach((field) => {
          if (typeof field.columnWidth === 'string') {
            field.columnWidth = parseInt(field.columnWidth.replace('px', ''));
          }
        });

        this.products_current_datasource.forEach((item) => {
          this.cols.forEach((x) => {
            if (x.fieldDataType == 'date') {
              if (item[x.field] == '0000-00-00') {
                item[x.field] = '';
              } else {
                try {
                  item[x.field] = this.datePipe.transform(
                    item[x.field],
                    'yyyy-MM-dd'
                  );
                } catch (e) {
                  console.log('Error transforming date:', e);
                }
              }
            }
          });
        });

        if (!postdata.sortby) {
          this.products_current_datasource.sort((a, b) => {
            if (a.priority === '' && b.priority !== '') {
              return 1;
            } else if (a.priority !== '' && b.priority === '') {
              return -1;
            } else {
              const priorityComparison = a.priority - b.priority;
              if (priorityComparison !== 0) {
                return priorityComparison;
              } else {
                if (a.applicationDate === null && b.applicationDate !== null) {
                  return 1;
                } else if (
                  a.applicationDate !== null &&
                  b.applicationDate === null
                ) {
                  return -1;
                } else {
                  return (
                    new Date(a.applicationDate).getTime() -
                    new Date(b.applicationDate).getTime()
                  );
                }
              }
            }
          });
        }

        this.isShowTable = true;
      },
      (errorobj) => {
        console.log('Error in data search:', errorobj);
        this.busyService.idle();
        this.loading_table = false;
      },
      () => {
        this.busyService.idle();
        this.loading_table = false; // Stop the loader in completion
      }
    );
  }

  getFilterCondition() {
    this.textsearch = '';
    this.analysisApi = false;

    let criteria: any[] = [];
    let filters: any[] = [];
    let analysisFilters: any[] = [];

    this.search_filters = new search_filter();
    this.searchedWords = [];
    this.application_query = '';

    // Get product
    let rawProduct =
      this.filterForm_normal.controls['textautocomplete'].value?.trim();

    let product = Array.isArray(this.current_Active_Ingredient)
      ? this.current_Active_Ingredient[0] || ''
      : String(this.current_Active_Ingredient || '');
      console.log('product from rxjs to quik', product);

    if (rawProduct) {
      const isChemicalName =
        /^[A-Z0-9,\-\s()]+$/i.test(rawProduct) && !rawProduct.includes(' OR ');
      product = isChemicalName
        ? rawProduct
        : rawProduct.split(/ OR |\(/)[0].trim();
    }

    // ❗ PRODUCT ALWAYS GOES ONLY IN CRITERIA + ANALYSIS FILTERS
    if (product) {
      criteria.push({
        field: 'product',
        keyword: product,
        operator: 'AND',
      });

      // Product filter for ANALYSIS only
      analysisFilters.push({
        product: { $regex: String(product), $options: 'i' },
      });

      this.application_query = `product : (${product})`;
      this.searchQueryGrid = `product:(${product})`;

      this.search_filters.SeachType = 'Simple Filter';
      this.search_filters.textColumn = ['product'];
      this.search_filters.textValue = [product];
    }

    // ---------------- PATENT TYPE → ONLY FILTERS ----------------
    const selectedPatentType = this.dynSelectedPatentType?.trim();
    if (selectedPatentType) {
      let ptFilter = {
        patentType: {
          $regex: `\\b${selectedPatentType}\\b`,
          $options: 'i',
        },
      };

      // Add to BOTH table filters & analysis
      filters.push(ptFilter);
      analysisFilters.push(ptFilter);

      this.application_query += ` AND PATENT TYPE:(${selectedPatentType})`;
    }

    // ---------------- SIMPLE SEARCH → COMMENTED PART REMAINS COMMENTED ----------------
    if (
      !this.isQueryOptionSelected &&
      this.searchOptions[this.selectedSearchOption]?.value === 'SIMPLE'
    ) {
      let searchtext = product;

      // let searchWordArr = [
      //   searchtext.replace(/[^a-zA-Z0-9\s]/g, '\\$&'),
      //   searchtext.replace(/[^\w\s]+/gi, ''),
      //   searchtext.replace(/[^\w\s]+/gi, ' '),
      // ];
    }

    // ---------------- ANALYSIS FILTERS ----------------
    if (this.analysisFilterVal?.length) {
      this.analysisFilterVal.forEach((val: any) => {
        let filterObj;

        if (val.filter === 'Company') {
          filterObj = {
            assignee: { $regex: String(val.value || ''), $options: 'i' },
          };
        } else if (val.filter === 'Application Date') {
          filterObj = {
            $expr: { $eq: [{ $year: '$applicationDate' }, val.value] },
          };
        } else {
          filterObj = {
            $expr: { $eq: [{ $year: '$publicationDate' }, val.value] },
          };
        }

        filters.push(filterObj);
        analysisFilters.push(filterObj);
      });
    }

    // ---------------- TABLE FILTERS ----------------
    let tableFilters = this._constant.getTableFilterCondition(this.tablefilter);

    // Add table filters to BOTH main filters & analysis filters
    filters = filters.concat(tableFilters);
    analysisFilters = analysisFilters.concat(tableFilters);

    // ⭐ Map snake_case to camelCase before returning to match new Backend Schema
    const mapping: any = {
      'patent_type': 'patentType',
      'patent_status': 'patentStatus',
      'legal_status': 'legalStatus'
    };

    const recursiveMap = (obj: any): any => {
      if (Array.isArray(obj)) {
        return obj.map(item => recursiveMap(item));
      } else if (obj !== null && typeof obj === 'object') {
        // If it's a Date or Regex, return as is
        if (obj instanceof Date || obj instanceof RegExp) return obj;
        
        let newObj: any = {};
        Object.keys(obj).forEach(key => {
          const targetKey = mapping[key] || key;
          newObj[targetKey] = recursiveMap(obj[key]);
        });
        return newObj;
      }
      return obj;
    };

    filters = recursiveMap(filters);
    analysisFilters = recursiveMap(analysisFilters);

    // ⭐ Return both TBL filters & ANALYSIS filters separately
    return { criteria, filters, analysisFilters, keywordSearchText: product };
  }

  splitColumnValue(
    columnValue: any,
    columnname: any,
    valType: any,
    operator: any
  ) {
    // debugger;
    let colValArr: any = [];
    if (columnname === 'patentType') {
      return this.patentCondition(columnValue, columnname, operator);
    } else if (columnname === 'dummy1') {
      return this.rangeCondition(columnValue, columnname, operator);
    } else if (
      columnValue.toLowerCase().indexOf('and') >= 0 ||
      columnValue.toLowerCase().indexOf('or') >= 0
    ) {
      let strArr = columnValue.split(/\sand\s|\sor\s/gi);
      let opStr = columnValue.match(/\b(?:and|or)\b/gi);
      strArr.forEach((str: any, index: any) => {
        colValArr.push({
          operator: index === 0 ? 'AND' : opStr[index - 1].toUpperCase(),
          value: str,
        });
      });
      return valType === 'text'
        ? this.textFieldCondition(colValArr, columnname, operator)
        : this.dateFieldCondition(colValArr, columnname, operator);
    } else {
      colValArr.push({ operator: 'AND', value: columnValue });
      return valType === 'text'
        ? this.textFieldCondition(colValArr, columnname, operator)
        : this.dateFieldCondition(colValArr, columnname, operator);
    }
  }

  textFieldCondition(colValArr: any, columnname: any, operator: any) {
    let andArr: any = [];
    let orArr: any = [];
    colValArr.forEach((val: any, i: any) => {
      let searchWordArr: any = [];
      let searchCondition: any = [];
      // searchWordArr.push(val.value.replace(/[^a-zA-Z0-9\s]/g, '\\$&'));
      // searchWordArr.push(val.value.replace(/[^\w\s]+/gi, ''));
      // searchWordArr.push(val.value.replace(/[^\w\s]+/gi, ' '));
      if (operator === 'NOT') {
        searchWordArr.forEach((text: any) => {
          if (this.searchType === 'Exact') {
            searchCondition.push({
              [columnname]: {
                $not: { $regex: `\\b${text}\\b`, $options: 'i' },
              },
            });
          } else {
            searchCondition.push({
              [columnname]: { $not: { $regex: text, $options: 'i' } },
            });
          }
        });
      } else {
        searchWordArr.forEach((text: any) => {
          if (this.searchType === 'Exact') {
            searchCondition.push({
              [columnname]: { $regex: `\\b${text}\\b`, $options: 'i' },
            });
          } else {
            searchCondition.push({
              [columnname]: { $regex: text, $options: 'i' },
            });
          }
        });
        if (this.searchType === 'Exact') {
          this.textsearch += ` ${val.value}`;
        }
      }

      if (i === 0 || val.operator === 'OR') {
        orArr.push({ $or: searchCondition });
      } else {
        andArr.push({ $or: searchCondition });
      }
    });
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }

    return andArr;
  }

  patentCondition(columnValue: any, columnname: any, operator: any) {
    let andArr = [];
    let searchCondition = [];
    if (operator === 'NOT') {
      if (this.searchType === 'Exact') {
        searchCondition.push({
          [columnname]: {
            $not: {
              $regex: `\\${columnValue.slice(0, columnValue.indexOf(' '))}\\b`,
              $options: 'i',
            },
          },
        });
      } else {
        searchCondition.push({
          [columnname]: {
            $not: {
              $regex: columnValue.slice(0, columnValue.indexOf(' ')),
              $options: 'i',
            },
          },
        });
      }
    } else {
      this.dynSelectedPatentType = columnValue;

      if (this.searchType === 'Exact') {
        searchCondition.push({
          [columnname]: {
            $regex: `\\${columnValue.slice(0, columnValue.indexOf(' '))}\\b`,
            $options: 'i',
          },
        });
        this.textsearch += ` ${columnValue.slice(0, columnValue.indexOf(' '))}`;
      } else {
        searchCondition.push({
          [columnname]: {
            $regex: columnValue.slice(0, columnValue.indexOf(' ')),
            $options: 'i',
          },
        });
      }
    }
    andArr.push({ $or: searchCondition });

    return andArr;
  }

  rangeCondition(columnValue: any, columnname: any, operator: any) {
    let andArr: any = [];
    let searchCondition: any = [];
    let valueArr = columnValue.split('-');
    // console.log(valueArr);
    let regex = /(?<stringValue>[a-z]+)(?<numericValue>[0-9]+)/i;
    const startMatch: any = regex.exec(valueArr[0]);
    const endMatch: any = regex.exec(valueArr[1]);

    if (operator === 'NOT') {
      searchCondition.push({
        [columnname]: {
          $not: {
            $regex: columnValue.slice(0, columnValue.indexOf(' ')),
            $options: 'i',
          },
        },
      });
    } else {
      searchCondition.push({
        numericPart: {
          $gte: parseInt(startMatch.groups.numericValue),
          $lte: parseInt(endMatch.groups.numericValue),
        },
        stringPart: {
          $gte: startMatch.groups.stringValue,
          $lte: endMatch.groups.stringValue,
        },
      });
    }
    andArr.push({ $or: searchCondition });

    return andArr;
  }

  dateFieldCondition(colValArr: any, columnname: any, operator: any) {
    let andArr: any = [];
    let orArr: any = [];
    colValArr.forEach((val: any, i: any) => {
      let inputValue = val.value.split('TO');
      for (let i = 0; i < inputValue.length; i++) {
        if (inputValue[i].indexOf('*') < 0) {
          let dateArr = inputValue[i].split('-');
          inputValue[i] =
            dateArr[2].trim() +
            '-' +
            dateArr[1].trim() +
            '-' +
            dateArr[0].trim();
        } else {
          inputValue[i] = inputValue[i].trim();
        }
      }
      let searchCondition: any = [];
      if (operator === 'NOT') {
        if (inputValue[1]) {
          if (inputValue[0] === '*') {
            searchCondition.push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else if (inputValue[1] === '*') {
            searchCondition.push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else {
            searchCondition.push({ $and: [] });
            searchCondition[0]['$and'].push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
            searchCondition[0]['$and'].push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          }
        } else {
          searchCondition.push({
            $expr: {
              $ne: [
                { $toDate: `$${columnname}` },
                {
                  $toDate: this.datePipe.transform(inputValue[0], 'yyyy-MM-dd'),
                },
              ],
            },
          });
        }
      } else {
        if (inputValue[1]) {
          if (inputValue[0] === '*') {
            searchCondition.push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else if (inputValue[1] === '*') {
            searchCondition.push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else {
            searchCondition.push({ $and: [] });
            searchCondition[0]['$and'].push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
            searchCondition[0]['$and'].push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          }
        } else {
          searchCondition.push({
            $expr: {
              $eq: [
                { $toDate: `$${columnname}` },
                {
                  $toDate: this.datePipe.transform(inputValue[0], 'yyyy-MM-dd'),
                },
              ],
            },
          });
        }
      }

      if (i === 0 || val.operator === 'OR') {
        orArr.push({ $or: searchCondition });
      } else {
        andArr.push({ $or: searchCondition });
      }
    });
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }
    return andArr;
  }

  dateConditionArr(colValArr: any, columnname: any, operator: any, i: any) {
    let andArr: any = [];
    let orArr: any = [];
    let searchCondition: any = [];
    if (operator === 'NOT') {
      if (colValArr[1]) {
        searchCondition.push({ $and: [] });
        searchCondition[0]['$and'].push({
          $expr: {
            $lte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
        searchCondition[0]['$and'].push({
          $expr: {
            $gte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[1], 'yyyy-MM-dd') },
            ],
          },
        });
      } else {
        searchCondition.push({
          $expr: {
            $ne: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
      }
    } else {
      if (colValArr[1]) {
        searchCondition.push({ $and: [] });
        searchCondition[0]['$and'].push({
          $expr: {
            $gte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
        searchCondition[0]['$and'].push({
          $expr: {
            $lte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[1], 'yyyy-MM-dd') },
            ],
          },
        });
      } else {
        searchCondition.push({
          $expr: {
            $eq: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
      }
    }

    if (i === 0 || operator === 'OR') {
      orArr.push({ $or: searchCondition });
    } else {
      andArr.push({ $or: searchCondition });
    }
    // });
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }
    return andArr;
  }

  resetSearch() {
    // this.searchType = '';
    this.isShowTable = false;
    this.isQueryOptionSelected = false;
    this.dynSelectedPatentType = '';
    this.searchQueryGrid = '';
    this.products_current_datasource = [];
    this.totalRecords = 0;
    this.tablefilter = {};
    this.currentSortBy = '';
    // this.backToListQuery = '';
    this.dateValue = {};
    // this.oldResult = {};
    // this.oldSearchQueryGrid = '';
    // this.isShowQueryBox = false;
    this.analysisFilterVal = [];
    this.analysisData = {};
    this.analysisDataKeys = [];
    this.analysisView = false;
    this.IsSuggestedItemClick = false;
    this.SuggestedDbColumn = '';
    this.SuggestedDbField = '';
    this.loadColumnDetails();
    this.filterForm_normal.controls['textautocomplete'].setValue('');
  }

  exportExcel(extention: any) {
    //Check User Privilege
    if (!this.checkUserDownloadPrivillege()) {
      return;
    }

    this.busyService.busy();
    const { criteria, filters } = this.getFilterCondition();
    let postdata = {
      search_type: this.searchType,
      criteria: criteria,
      pagenumber: this.current_pagenumber,
      rowscount: this.rows,
      sortby: this.currentSortBy || '',
      filters: filters,
      subFilters: {},

      activityObj: {
        userId: this.user_data.userid || '',
        privilegeName: 'quikpatent_search',
        mode: 'search',
        query: this.application_query || 'N/A',
        searchFilters: this.search_filters || 'N/A',
        userIp: this.user_ip || '',
        address: this.address || '',
      },

      product: this.current_Active_Ingredient,
    };

    this.datasearch.quik_patent_data(postdata).subscribe(
      (response) => {
        //console.log(response);
        // response[0].forEach((row, index)=>{
        //   row.S_NO = index+1;
        // });
        let DownloadData = response.data.results;
        this.rptDataForExcel = [];

        let header_temp: any = [];
        this.cols.map((col) => {
          if (col.isDisplay == 1) header_temp.push(col.header);
        });

        DownloadData.sort((a: any, b: any) => {
          if (a.priority === '' && b.priority !== '') {
            return 1;
          } else if (a.priority !== '' && b.priority === '') {
            return -1;
          } else {
            const priorityComparison = a.priority - b.priority;
            if (priorityComparison !== 0) {
              return priorityComparison;
            } else {
              if (a.applicationDate === null && b.applicationDate !== null) {
                return 1;
              } else if (
                a.applicationDate !== null &&
                b.applicationDate === null
              ) {
                return -1;
              } else {
                return (
                  new Date(a.applicationDate).getTime() -
                  new Date(b.applicationDate).getTime()
                );
              }
            }
          }
        });

        DownloadData.forEach((row: any, index: any) => {
          row.S_NO = index + 1;
        });

        DownloadData.forEach((row: any) => {
          let rowValues: any = [];
          this.cols.forEach((col) => {
            rowValues.push(row[col.field]);
          });
          this.rptDataForExcel.push(rowValues);
        });

        let reportData = {
          title: `${this.pageTitile} Data Report`,
          data: this.rptDataForExcel,
          headers: header_temp,
          sheetname: 'data',
          file_extention: extention,
          searchterm: this.searchQueryGrid,
        };

        this.exportdataService.exportExcel(reportData);
      },
      (error) => {
        console.log(error);
        this.busyService.idle();
      },
      () => {
        this.busyService.idle();
      }
    );
  }

  exportPdf() {
    //Check User Privilege
    if (!this.checkUserDownloadPrivillege()) {
      return;
    }

    this.busyService.busy();
    const { criteria, filters } = this.getFilterCondition();
    let postdata = {
      search_type: this.searchType,
      criteria: criteria,
      pagenumber: this.current_pagenumber,
      rowscount: this.rows,
      sortby: this.currentSortBy || '',
      filters: filters,
      subFilters: {},

      activityObj: {
        userId: this.user_data.userid || '',
        privilegeName: 'quikpatent_search',
        mode: 'search',
        query: this.application_query || 'N/A',
        searchFilters: this.search_filters || 'N/A',
        userIp: this.user_ip || '',
        address: this.address || '',
      },

      product: this.current_Active_Ingredient,
    };

    this.datasearch.quik_patent_data(postdata).subscribe(
      (response: any) => {
        //console.log(response);
        // response[0].forEach((row, index)=>{
        //   row.S_NO = index+1;
        // });
        let DownloadData = response[0];
        this.rptDataForExcel = [];

        let columns = this.cols
          .filter((x) => x.isDisplay == 1)
          .map((col) => ({
            title: col.header,
            dataKey: col.field,
          }));
        DownloadData.sort((a: any, b: any) => {
          if (a.priority === '' && b.priority !== '') {
            return 1;
          } else if (a.priority !== '' && b.priority === '') {
            return -1;
          } else {
            const priorityComparison = a.priority - b.priority;
            if (priorityComparison !== 0) {
              return priorityComparison;
            } else {
              if (a.applicationDate === null && b.applicationDate !== null) {
                return 1;
              } else if (
                a.applicationDate !== null &&
                b.applicationDate === null
              ) {
                return -1;
              } else {
                return (
                  new Date(a.applicationDate).getTime() -
                  new Date(b.applicationDate).getTime()
                );
              }
            }
          }
        });

        DownloadData.forEach((row: any, index: any) => {
          row.S_NO = index + 1;
        });

        DownloadData.forEach((row: any) => {
          let rowValues: any = [];
          this.cols.forEach((col) => {
            rowValues.push(row[col.field]);
          });
          this.rptDataForExcel.push(rowValues);
        });
        let reportData = {
          title: `${this.pageTitile} Data Report`,
          data: this.rptDataForExcel,
          headers: columns,
          sheetname: 'data',
        };

        this.exportdataService.exportPdf(reportData);
        this.busyService.idle();
      },
      (error: any) => {
        this.busyService.idle();
      },
      () => {
        this.busyService.idle();
      }
    );
  }

  checkUserSearchPrivillege(): boolean {
    this.IsFilterAplied = false;

    //Check User Have Access to Search
    if (!this.privilege_json.View) {
      console.log('User does not have view access');
      this.is_show_Search_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to view this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todaySearchCount =
      Number(this.privilege_json.today_search_count) || 0;
    const dailySearchLimit = Number(this.privilege_json.DailySearchLimit) || 0;
    console.log(
      `Checking daily search limit: today=${todaySearchCount}, limit=${dailySearchLimit}`
    );
    if (todaySearchCount >= dailySearchLimit) {
      console.log('Daily search limit exceeded');
      this.is_show_Daily_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily search limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const searchCount = Number(this.privilege_json.Search) || 0;
    console.log(`Checking total search count: remaining=${searchCount}`);
    if (searchCount <= 0) {
      console.log('Total search count exceeded');
      this.is_show_Total_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available search limit.',
      });
      return false;
    }

    this.IsFilterAplied = true;
    this.privilege_json.Search = searchCount - 1;
    this.privilege_json.today_search_count = todaySearchCount + 1;

    // Save updated counts to localStorage
    const userid = this.user_data?.userid || 'guest';
    const dailyKey = `user_${userid}_daily_counts`;

    const today = new Date().toDateString();
    localStorage.setItem(
      dailyKey,
      JSON.stringify({
        date: today,
        today_search_count: this.privilege_json.today_search_count,
        today_download_count: this.privilege_json.today_download_count || 0,
      })
    );

    console.log(
      `Updated search counts: total=${this.privilege_json.Search}, today=${this.privilege_json.today_search_count}`
    );
    return true;
  }

  checkUserDownloadPrivillege(): boolean {
    console.log('Checking download privileges');
    //Check User Have Access to Search
    if (!this.privilege_json.Download) {
      console.log('User does not have download access');
      this.is_show_Download_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to download data from this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todayDownloadCount =
      Number(this.privilege_json.today_download_count) || 0;
    const dailyDownloadLimit =
      Number(this.privilege_json.DailyDownloadLimit) || 0;
    console.log(
      `Checking daily download limit: today=${todayDownloadCount}, limit=${dailyDownloadLimit}`
    );
    if (todayDownloadCount >= dailyDownloadLimit) {
      console.log('Daily download limit exceeded');
      this.is_show_Daily_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily download limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const downloadCount = Number(this.privilege_json.DownloadCount) || 0;
    console.log(`Checking total download count: remaining=${downloadCount}`);
    if (downloadCount <= 0) {
      console.log('Total download count exceeded');
      this.is_show_Total_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available download limit.',
      });
      return false;
    }
    this.privilege_json.DownloadCount = downloadCount - 1;
    this.privilege_json.today_download_count = todayDownloadCount + 1;

    // Save updated counts to localStorage
    const today = new Date().toDateString();
    const userData = {
      date: today,
      today_search_count: this.privilege_json.today_search_count,
      today_download_count: this.privilege_json.today_download_count,
    };
    localStorage.setItem(
      `user_${this.user_data.userid}_daily_counts`,
      JSON.stringify(userData)
    );

    console.log(
      `Updated download counts: total=${this.privilege_json.DownloadCount}, today=${this.privilege_json.today_download_count}`
    );

    return true;
  }

  showRaiseQuery() {
    let email = this.user_data.email;
    this.form_RaiseQuery.controls['txtResponseEmail'].setValue(email);
    this.form_RaiseQuery.controls['txtQuery'].setValue('');

    this.isShowRaiseQuery = true;
    const modalElement = document.getElementById('raise_query_modal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();
      }
    }
  }
  // Raise Query old way
  // submitRaiseQueryForm() {
  //   let emailPostData = {
  //     to: 'support@chemrobotics.com',
  //     subject: 'ChemRobotics - QuikPatent - User Query',
  //     html: `
  //           <div style="background-color: #ffc702; heigth:30px; text-align: center;">
  //           <img src="cid:logoImg" alt="Logo">
  //           </div>
  //           <div style="background-color: #eee;">
  //           <p>User Email: (<strong>${this.form_RaiseQuery.controls['txtResponseEmail'].value}</strong>)</p>
  //           <p>User Comment: <strong>${this.form_RaiseQuery.controls['txtQuery'].value}</strong></p>
  //           <p>Search Query:</p>
  //           </div>
  //           <p>${this.searchQueryGrid}</p>
  //           <div style="background-color: #eee;">
  //           <p>Thank You!</p>
  //           <p>Team ChemRobotics</p>
  //           <p><img src="cid:logoImg" alt="Logo"></p>
  //           <p><strong>✉️ support@chemrobotics.com</strong></p>
  //           <p><strong>📞 +91-6266117944</strong>, <strong>+91-9407360810</strong></p>
  //           </div>
  //           <hr>
  //           <div style="background-color: #eee; text-align: center;">
  //           <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics</a></strong></p>
  //           <div/>`,
  //   };

  //   let postdata = {
  //     mode: 'ADD_USER_QUERY',
  //     userid: this.user_data,
  //     usercomment: this.form_RaiseQuery.controls['txtQuery'].value,
  //     searchquery: this.search_filters,
  //   };

  //   this.datasearch.userMasterManage(postdata).subscribe((res) => {});
  //   this.datasearch.sendMail(emailPostData).subscribe((res) => {
  //     this.isShowRaiseQuery = false;
  //     this.submittedquerybox();
  //   });
  // }

  // Raise Query new way
  submitRaiseQueryForm() {
    let emailPostData = new FormData();
    emailPostData.append('to', 'support@chemrobotics.com');
    emailPostData.append('cc', 'greenbookcorp@gmail.com');
    emailPostData.append('cc', 'chemroboticsros@gmail.com');
    emailPostData.append(
      'subject',
      'ChemRobotics - BetaQuikPatent - User Query'
    );
    emailPostData.append(
      'html',
      `<div style="background-color: #ffc702; heigth:30px; text-align: center;">
            <img src="cid:logoImg" alt="Logo">
            </div>
            <div style="background-color: #eee;">
            <p>User Email: (<strong>${this.form_RaiseQuery.controls['txtResponseEmail'].value}</strong>)</p>
            <p>User Comment: <strong>${this.form_RaiseQuery.controls['txtQuery'].value}</strong></p>
            <p>Search Query:</p>
            </div>
            <p>${this.searchQueryGrid}</p>
            <div style="background-color: #eee;">
            <p>Thank You!</p>
            <p>Team ChemRobotics</p>
            <p><img src="cid:logoImg" alt="Logo"></p>
            <p><strong>✉️ support@chemrobotics.com</strong></p>
            <p><strong>📞 +91-6266117944</strong>, <strong>+91-9407360810</strong></p>
            </div>
            <hr>
            <div style="background-color: #eee; text-align: center;">
            <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics</a></strong></p>
            <div/>`
    );

    if (this.selectedFile) {
      emailPostData.append('file', this.selectedFile);
    }

    let postdata = {
      mode: 'ADD_USER_QUERY',
      userid: this.user_data.userid,
      usercomment: this.form_RaiseQuery.controls['txtQuery'].value,
      searchquery: this.search_filters,
    };

    this.datasearch.userMasterManage(postdata).subscribe((res) => {});
    this.busyService.busy();
    this.datasearch.sendMailNew(emailPostData).subscribe(
      (res) => {
        this.busyService.idle();
        this.isShowRaiseQuery = false;
        this.form_RaiseQuery.reset({
          txtResponseEmail: '',
          txtQuery: '',
        });
        this.fileInput.nativeElement.value = '';
        this.selectedFile = null;
        // this.submittedquerybox();
      },
      (error) => {
        this.busyService.idle();
        console.log('Error on Raise Query : ', error);
      }
    );
  }

  // submittedquerybox() {
  //   const alertModalElement = document.getElementById('Querysubmitalert');
  //   if (alertModalElement) {
  //     $('#Querysubmitalert').modal('show');
  //     setTimeout(() => {
  //       $('#Querysubmitalert').modal('hide');
  //     }, 5000);
  //   }
  // }
  showFieldSettingModal() {
    const modalElement = document.getElementById('field_setting_modal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();
      }
    }
  }
  showFullScreen() {
    this.isFullScreen = true;
    const tableElement = this.renderer.selectRootElement('#tabledata', true);
    if (tableElement) {
      this.renderer.addClass(tableElement, 'full-screen-table');
    }
  }

  exitFullScreen() {
    this.isFullScreen = false;
    const tableElement = this.renderer.selectRootElement('#tabledata', true);
    if (tableElement) {
      this.renderer.removeClass(tableElement, 'full-screen-table');
    }
  }

  increment(col: any) {
    col.columnWidth = (col.columnWidth || 0) + 1;
  }

  decrement(col: any) {
    col.columnWidth = (col.columnWidth || 0) - 1;
  }
  scrollLeft() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft -= 500) : '';
  }
  scrollRight() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft += 500) : '';
  }

  hideColumnsBasedOnData() {
  this.cols = this.cols.filter((col) => {
    if (col.field === 'S_NO') return true; // Always show S.No if it's in the config
    return this.products_current_datasource.some((row) => {
      const value = row[col.field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'string') {
        return value.trim() !== '';
      }

      return value !== null && value !== undefined;
    });
  });
}


  // Raise Query file upload veriables
  @ViewChild('fileInput') fileInput!: ElementRef;
  selectedFile: File | null = null;
  maxFileSizeMB = 10;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      if (file.size > this.maxFileSizeMB * 1024 * 1024) {
        alert('File is too large. Please select a file under 10 MB.');
        this.fileInput.nativeElement.value = '';
        this.selectedFile = null;
        return;
      }

      this.selectedFile = file;
    }
  }

  setIpandLocation() {
    this.datasearch.getIpandLocation().subscribe({
      next: (res) => {
        this.user_ip = res.userip;
        this.address = res.address;
        console.log('🌐 User Info:', res);
      },
      error: (err) => {
        console.error('❌ Error fetching IP/Location:', err);
      },
    });
  }

  handlePageLimit() {
    this.pageLimitInPrivilegeJson = this.privilege_json.PageLimit
      ? Number(this.privilege_json.PageLimit)
      : 0;
  }

  // handlePageLimit() {
  //   this.pageLimitInPrivilegeJson = this.privilege_json.PageLimit
  //     ? this.privilege_json.PageLimit
  //     : 0;
  // }
  // goBackToSearch() {

  //   this.currentFilterCondition = '';
  // //  this.loadColumnDetails();
  //   this.searchData();
  // }
}
